export default "__VITE_ASSET__CbfqQUxP__"